import React from "react";
import Layout from "../../components/common/layout";
import HyperStatsTable from "../../components/tables/HyperStatsTable";

export default () => {
  return (
    <Layout>
      <div>
        <div className="content" style={{ padding: 30 }}>
          <h2>Hyper Stats</h2>
          <h6>Recommended Hyper Stats order</h6>
          <div>
            <blockquote>
              Credit: Thanks to Sally for the order recommendation!
            </blockquote>
          </div>
          <ol>
            <li>Final Damage Inc.</li>
            <li>Phy/Mag Damage Inc.</li>
            <li>
              Max Damage Inc.<strong>*</strong>
            </li>
            <li>Chance of Additional DMG when attacking</li>
            <li>Crit Damage Inc.</li>
            <li>Boss Atk Inc.</li>
          </ol>
          <div>
            <strong>*</strong>If you do not hit the max damage yet, it's
            recommended that you can skip this stat and get the next in the
            order
          </div>
        </div>
      </div>
      <div
        style={{
          borderTop: "1px solid #6f6f6f6f",
          margin: "auto",
          width: "50vw",
          padding: "20px 10px 0",
        }}
      />
      <HyperStatsTable />
    </Layout>
  );
};
